import DashboardConstants from "@/store/constants/dashboardRecords";
import DashboardServices from "@/services/DashboardServices";
import DashboardInternalData from "@/internalData/Dashboard"

export default {
  name: "CommonInstructionsPrintFunction",
  data() {
    return {
      isDisable: true,
      borderHeaderFields: DashboardInternalData.commonInstructions.borderHeaderFields,
    };
  },
  computed: {
    statusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    commonsRecord() {
      return this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].commons;
    },
    isHideCommonRecords(){
      return !this.commonsRecord.hideRevision
    },
  },
  methods: {
    getColspan(index){
      return index<2 ? 1 : 2
    },
    previouValueCondition(attr) {
      const notHide = !this.$_.get(this.commonsRecord, "hideRevision"); //hide const use to dectect nil value previous
      const notCondition = !this.$_.get(this.commonsRecord, ["style", attr, "condition"].join("."));
      return notHide && notCondition;
    },
    stylePreivous(attr) {
      return this.$_.get(this.commonsRecord, ["style", attr, "previous"].join("."));
    },
    previousValue(attr) {
      return this.$_.get(this.commonsRecord, ["previousItem", attr].join("."));
    },
    styleLastest(attr) {
      return this.$_.get(this.commonsRecord, ["style", attr, "lastest"].join("."));
    },
    isImageBaseURL(sign){
      return DashboardServices.isImageBaseURL(sign)
    },
  }
};